import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SectionContainer } from './styles';
import DateRanges from './filters-components/date-ranges';
import Contributors from './filters-components/contributors';

const Container = styled(SectionContainer)`
  display: flex;
  justify-content: flex-end;
  margin-top: 60px;
  margin-bottom: -148px;
`;

export default function Filters({
  contributors, daysAgo, onContributorsChange, onDateChange,
}) {
  const cProps = { contributors, onChange: onContributorsChange };
  const drProps = { daysAgo, onChange: onDateChange };
  return (
    <Container>
      {(contributors.length > 1) && <Contributors {...cProps} />}
      <DateRanges {...drProps} />
    </Container>
  );
}

Filters.propTypes = {
  contributors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    profilePictureUrl: PropTypes.string,
    selected: PropTypes.bool.isRequired,
  })).isRequired,
  daysAgo: PropTypes.number.isRequired,
  onContributorsChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
};
